import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=7cf7fe99&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf7fe99"]])

export default __exports__